"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alignContentMap = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    between: 'space-between',
    around: 'space-around',
    stretch: 'stretch',
};
// eslint-disable-next-line no-confusing-arrow
exports.default = (function (_a) {
    var alignContent = _a.alignContent;
    return alignContent in alignContentMap ? "align-content: " + alignContentMap[alignContent] + ";" : '';
});
